module.exports = __webpack_public_path__ + "static/14-8de58c19d25b5cc53d2724709628f2f2.png";